import { render, staticRenderFns } from "./sort_dropdown.vue?vue&type=template&id=f6c9ae7c"
import script from "./sort_dropdown.vue?vue&type=script&lang=js"
export * from "./sort_dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports